<div class="modal-header">
    <h1 class="modal-title" id="modal-basic-title">{{ 'envelope.edit-modal.headerEdit' | translate }} </h1>
    <button type="button" class="cdx-btn__close icon" aria-label="Close" (click)="modalClose()">
        <fa-icon fa-fw="true" [icon]="['far','times']"></fa-icon>
    </button>
</div>
<div class="modal-body mt-n3">
    <h4 >{{ 'envelope.edit-modal.subTitle' | translate }}
    </h4>
    <form #f="ngForm" [formGroup]="envelopeForm">
        <div class="form-row mt-2">
            <div class="form-group col-md-12" [ngClass]="{ 'has-error': envelopeForm.get('expiration').hasError('dateInvalid') }">
                <label>{{ "envelope.edit-modal.expirationText" | translate | titlecase }}</label>
                <div class="mt-n2">
                <cdx-date-picker-container
                    [options]="datePickerContainerOptions"
                    [model]="datePickerContainerModel"
                    (onSelectedDate)="onExpirationSelectItem($event)">
                </cdx-date-picker-container>
              </div>
            </div>
        </div>
        <div class="form-row mt-n3">
            <div class="form-group col-md-12" [ngClass]="{ 'has-error': envelopeForm.get('reminderFrequency').hasError('invalid') }">
                <label > {{'envelope.edit-modal.reminderFrequencyText' | translate}}</label>
                <cdx-dropdown
                    [options]="rememberOptions"
                    [selectedItem]="reminderSelected"
                    (onSelectItem)="onReminderSelectItem($event)">
                </cdx-dropdown>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12" [ngClass]="{ 'has-error': envelopeForm.get('segment').hasError('invalid') }">
                <label>{{ "envelope.edit-modal.segmentText" | translate | titlecase }} </label>
                <cdx-dropdown
                    [options]="segmentDropdown"
                    [selectedItem]="segmentSelected"
                    (onSelectItem)="onSegmentSelectItem($event)">
                </cdx-dropdown>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer pr-3">
    <div class="row align-items-center justify-content-end pt-1 pb-1">
        <button class="cdx-button cdx-button--tertiary ml-0" (click)="modalClose()">
            <span class="cdx-button__text">{{ 'cancel' | translate | uppercase }}</span>
        </button>
        <button class="cdx-button cdx-button--primary ml-0" (click)="editEnvelope()" [disabled]="!(this.envelopeForm.valid)">
            <span class="cdx-button__text">{{ 'envelope.edit-modal.conclude' | translate | uppercase}}</span>
        </button>
    </div>
</div>
